var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptimize = function SvgOptimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 80,
    fill: "none",
    viewBox: "0 0 94 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.5 10h-6a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 22H2.5A1.5 1.5 0 0 0 1 23.5v3A1.5 1.5 0 0 0 2.5 28H19a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 19 22M92.5 22H46a1.5 1.5 0 0 0-1.5 1.5v3A1.5 1.5 0 0 0 46 28h46.5a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58.5 70h6a3 3 0 0 0 3-3V43a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M76 58h16.5a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5H76a1.5 1.5 0 0 0-1.5 1.5v3A1.5 1.5 0 0 0 76 58M2.5 58H49a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 49 52H2.5A1.5 1.5 0 0 0 1 53.5v3A1.5 1.5 0 0 0 2.5 58",
    opacity: 0.4
  })));
};
export default SvgOptimize;